import CryptoJS from 'crypto-js'

export default {
    //随机生成指定数量的16进制key
    generatekey(num) {
        const library = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
        let key = ''
        for (var i = 0; i < num; i++) {
            const randomPoz = Math.floor(Math.random() * library.length)
            key += library.substring(randomPoz, randomPoz + 1)
        }
        return key
    },

    //加密
    encrypt(word, keyStr) {
        keyStr = keyStr ? keyStr : 'f484392eba1caf703ec575d4e8b745c4'//判断是否存在ksy，不存在就用定义好的key
        var key = CryptoJS.enc.Utf8.parse(keyStr)
        var encrypted = CryptoJS.AES.encrypt(word, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
        return encrypted.ciphertext.toString().toUpperCase()
    },
    //解密
    decrypt(word, keyStr) {
        keyStr = keyStr ? keyStr : 'f484392eba1caf703ec575d4e8b745c4'
        var key = CryptoJS.enc.Utf8.parse(keyStr)
        var decrypt = CryptoJS.AES.decrypt(word, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
        return CryptoJS.enc.Utf8.stringify(decrypt).toString()
    }
}


// WEBPACK FOOTER //
// ./src/utils/AES.js